import { useSelector } from 'react-redux';

/**
 * useTrips hook.
 * Provide access to trips state and utilities to get departure and return trips by search ID.
 * @returns {object} props - trips, getDepartureTripsById, getReturnTripsById.
 * @returns {object} props.trips - Object with all trips.
 * @returns {Function} props.getDepartureTripsById - Get departure trips by search ID.
 * @returns {Function} props.getReturnTripsById - Get return trips by search ID.
 */
function useTrips() {
  const trips = useSelector((state) => state.trips.toJS());

  /**
   * Gets departure trips by search ID
   * @param {string} searchId - Search ID
   * @returns {Array} Departure trips.
   */
  const getDepartureTripsById = (searchId) => {
    return trips[searchId]?.buses?.trips || [];
  };

  /**
   * Gets return trips by search ID
   * @param {string} searchId - Search ID
   * @returns {Array} Return trips.
   */
  const getReturnTripsById = (searchId) => {
    return trips[searchId]?.buses?.trips || [];
  };

  return { trips, getDepartureTripsById, getReturnTripsById };
}

export default useTrips;
